var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTequilaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.5958 120.906C96.1137 123.914 98.1375 126.637 100.575 128.974C101.1 129.48 101.652 129.958 102.213 130.409C105.716 133.291 109.886 135.371 114.461 136.384C117.933 137.152 120.85 134.195 120.85 130.639V107.715M150.223 107.715H85.1484C81.592 107.715 78.6575 110.615 79.2014 114.129C79.8039 118.023 80.9441 121.747 82.5358 125.23C84.7896 130.105 87.9265 134.493 91.7349 138.182C94.4395 140.758 97.466 142.975 100.759 144.76C106.729 148.016 113.555 149.856 120.85 149.856C132.156 149.856 142.358 145.431 149.974 138.182C156.512 131.946 161.076 123.57 162.516 114.13C163.052 110.615 160.117 107.715 156.561 107.715H150.223Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5956 120.906C92.5994 116.932 91.4863 112.462 91.4863 107.715H150.223C150.223 116.068 146.782 123.565 141.125 128.974C135.844 134.006 128.715 137.078 120.85 137.078C113.767 137.078 107.29 134.585 102.212 130.409",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.851 107.715L102.582 126.757L100.576 128.845",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.124 128.845L120.85 107.715",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.85 137.078V107.715",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5356 125.231C81.7168 125.387 80.8705 125.516 79.9874 125.626C79.6195 125.682 79.2515 125.718 78.8743 125.755C78.58 125.792 78.2856 125.82 77.982 125.847H77.9452C77.4761 125.893 76.9977 125.93 76.5194 125.958C76.2802 125.958 76.041 125.985 75.7926 125.994C75.5535 126.004 75.3051 126.022 75.0659 126.022C74.8083 126.04 74.5507 126.05 74.2932 126.05C73.8332 126.059 73.3549 126.068 72.8765 126.068C72.2878 126.068 71.7082 126.059 71.1379 126.04C53.0104 125.466 44.5207 116.47 41.6268 112.218C41.4845 112.009 41.3993 111.771 41.3679 111.52V111.52C41.2637 110.687 41.133 109.461 41.0758 108.624C40.5551 100.992 38.3468 65.0093 37.4162 49.8063C37.1895 46.1026 40.1338 43 43.8444 43H103.937C107.747 43 110.724 46.2896 110.344 50.0806L104.577 107.716",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5977 120.907C96.1155 123.915 98.1393 126.638 100.577 128.975C101.101 129.481 101.653 129.959 102.215 130.41",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5977 120.907V120.897",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.76 144.761V144.761C100.441 147.936 97.7687 150.354 94.5774 150.354H49.8448C46.4496 150.354 43.6377 147.717 43.4188 144.329L41.3242 111.901C44.0012 116.013 52.2344 125.488 71.1385 126.04C71.7089 126.059 72.2884 126.068 72.8771 126.068C73.3555 126.068 73.8339 126.059 74.2938 126.05C74.5514 126.05 74.809 126.04 75.0665 126.022C75.3057 126.022 75.5541 126.004 75.7933 125.994C76.0416 125.985 76.2808 125.967 76.52 125.958C76.9983 125.93 77.4767 125.893 77.9459 125.847H77.9827C78.2862 125.82 78.5806 125.792 78.875 125.755C79.2521 125.718 79.6201 125.682 79.9881 125.626C80.8712 125.516 81.7175 125.387 82.5362 125.231",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTequilaIcon);
export default __webpack_public_path__ + "static/media/tequila-icon.7622c7462f06ab2f4f3fb7c86727f9e3.svg";
export { ForwardRef as ReactComponent };